// extracted by mini-css-extract-plugin
export default {"main":"style_main__M+XFM","container":"style_container__APvxo"};